import { render } from "./person-nationality-list.vue?vue&type=template&id=37827e13"
import script from "./person-nationality-list.vue?vue&type=script&lang=js"
export * from "./person-nationality-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__